import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import Main from './Main';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode><Main /></React.StrictMode>
);
